import React from 'react';

const ER = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_158"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_158)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#3C87E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V8H0V0Z"
        fill="#00AF1E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0L21 7.5L0 15V0Z"
        fill="#ED0030"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7.50001C9 6.12001 7.88 5.00001 6.5 4.50001C5.12 5.00001 4 6.12001 4 7.50001C4 8.71001 4.86 9.71801 6 9.95001V6.49801C6 6.22301 6.232 6.00001 6.5 6.00001C6.776 6.00001 7 6.21501 7 6.49801V9.95001C8.14 9.71801 9 8.71001 9 7.50001ZM10 7.50001C10 5.56701 8.433 4.00001 6.5 4.50001C4.567 4.00001 3 5.56701 3 7.50001C3 9.43301 4.567 11 6.5 11C8.433 11 10 9.43301 10 7.50001Z"
        fill="#FFC800"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default ER;
